<div class="modal-header">
  <app-summary-top class="w-100" [header]="header" [showSave]="showSave"></app-summary-top>
</div>

<div class="modal-body p-3">
  <app-base-inline-form [fields]="fields" [model]="model"></app-base-inline-form>

  <app-grid
    gridCssClass="modal-grid"
    [stateKey]="gridStateKey"
    [columnDefs]="columnDefs"
    [rowData]="results$ | async"
    [showDelete]="false"
    (edit)="edit($event)"
  ></app-grid>
</div>
